import type { ReactNode } from "react"
import "./centeredMessagePage.css"

type CenteredMessagePageProps = {
  className: "contact-form-thanks" | "page-error"
  title: string
  children: ReactNode
  linkHref: string
  linkLabel: string
}

export function CenteredMessagePage({
  className,
  title,
  children,
  linkHref,
  linkLabel,
}: CenteredMessagePageProps) {
  return (
    <div className={`container ${className}`}>
      <h1>{title}</h1>
      <div>{children}</div>
      <a
        className="message-page-link"
        href={linkHref}
      >
        {linkLabel}
      </a>
    </div>
  )
}
